import { render, staticRenderFns } from "./DeviceControlCardSOOB.vue?vue&type=template&id=68a8f43e&scoped=true&"
import script from "./DeviceControlCardSOOB.vue?vue&type=script&lang=js&"
export * from "./DeviceControlCardSOOB.vue?vue&type=script&lang=js&"
import style0 from "./DeviceControlCardSOOB.vue?vue&type=style&index=0&id=68a8f43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8f43e",
  null
  
)

export default component.exports